export default "__VITE_ASSET__BYENOOFl__"